module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part"
  }, [_c('h1', {
    staticClass: "part",
    attrs: {
      "id": "p01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#pt01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("“During the last thousand years, a Sassoon"), _c('br'), _vm._v(" has never been known to be wrong.”"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("– Ernest O. Hauser,")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("“The Fabulous Sassoons,”")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("The American Mercury")]), _vm._v(", 1940.")]), _vm._v(" "), _c('p', {
    staticClass: "comm"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/comm1.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "page18"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1924ba6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/p01.vue
// module id = 78
// module chunks = 0